// Sebaran.reducer.js
import {
  GET_BATAS_WILAYAH,
  GET_SEKOLAH_SEBARAN,
} from "../actions/Sebaran.actions";

const initialState = {
  batas_wilayah: null,
  sekolah_sebaran: [],
};

export default function SebaranReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BATAS_WILAYAH:
      return {
        ...state,
        batas_wilayah: action.payload,
      };
    case GET_SEKOLAH_SEBARAN:
      return {
        ...state,
        sekolah_sebaran: action.payload,
      };
    default:
      return state;
  }
}
